import React from 'react';
import BlogPage from '../components/BlogPage/BlogPage';

export default function Blog() {
    return (
        <div>
           <BlogPage /> 
        </div>
    )
}
